import { useState } from 'react';
import { Lock, Eye, EyeOff, LogIn } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AdminLoginPage({ onLogin }) {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API}/admin/login`, { password });
      if (response.data.success) {
        // Store auth in sessionStorage
        sessionStorage.setItem('adminAuthenticated', 'true');
        sessionStorage.setItem('adminAuthTime', Date.now().toString());
        onLogin();
      }
    } catch (err) {
      if (err.response?.status === 401) {
        setError('Incorrect password. Please try again.');
      } else {
        setError('Authentication failed. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen pt-24 bg-[#FAFAF5] flex items-center justify-center" data-testid="admin-login-page">
      <div
        
        
        className="w-full max-w-md mx-4"
      >
        <div className="bg-white p-8 md:p-12 shadow-sm">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-black rounded-full flex items-center justify-center mx-auto mb-4">
              <Lock size={24} className="text-white" />
            </div>
            <h1 className="font-serif text-3xl font-bold text-black mb-2">Admin Access</h1>
            <p className="text-neutral-500 text-sm">Enter your password to continue</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-xs tracking-wider uppercase text-neutral-500 mb-2">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  data-testid="admin-password-input"
                  className="w-full bg-transparent border border-neutral-200 px-4 py-3 pr-12 text-black focus:border-black focus:outline-none"
                  placeholder="Enter admin password"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 text-neutral-400 hover:text-black"
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            {error && (
              <p
                
                
                className="text-red-600 text-sm text-center"
                data-testid="login-error"
              >
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={isLoading}
              data-testid="admin-login-btn"
              className="w-full bg-black text-white px-8 py-4 text-xs tracking-widest uppercase font-bold hover:bg-neutral-800 transition-all disabled:opacity-50 flex items-center justify-center"
            >
              {isLoading ? (
                'Verifying...'
              ) : (
                <>
                  Access Dashboard
                  <LogIn size={16} className="ml-2" />
                </>
              )}
            </button>
          </form>

          <p className="text-center text-neutral-400 text-xs mt-6">
            This area is restricted to authorized personnel only.
          </p>
        </div>
      </div>
    </div>
  );
}
